(function(){
  function parseDate(value){
    if(!value) return null;
    var d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  function minsAgo(value){
    var d = parseDate(value);
    if(!d) return null;
    return Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
  }
  function agoText(value){
    var mins = minsAgo(value);
    if(mins === null) return 'never';
    if(mins < 1) return 'just now';
    if(mins === 1) return '1 min ago';
    if(mins < 60) return mins + ' mins ago';
    var hours = Math.round(mins / 60);
    if(hours === 1) return '1 hour ago';
    if(hours < 48) return hours + ' hours ago';
    return Math.round(hours / 24) + ' days ago';
  }
  function setState(el, state, text, title){
    el.classList.remove('is-online','is-delayed','is-offline','is-checking');
    el.classList.add('is-' + state);
    var textEl = el.querySelector('.dlb-adminhub-status__text');
    if(textEl) textEl.textContent = text;
    if(title) el.title = title;
  }
  async function fetchWithTimeout(url, timeout){
    var controller = new AbortController();
    var id = setTimeout(function(){ controller.abort(); }, timeout || 5000);
    try{
      var response = await fetch(url, { signal: controller.signal, cache: 'no-store', headers: { 'Accept': 'application/json' }});
      if(!response.ok) throw new Error('HTTP ' + response.status);
      return await response.json();
    } finally {
      clearTimeout(id);
    }
  }
  function classify(data){
    if(!data || data.online === false) return 'offline';
    var stock = data.stockSync || {};
    if(stock.status === 'warning') return 'delayed';
    if(stock.status === 'delayed') return 'delayed';
    if(stock.failClosedActive || Number(stock.consecutiveFailures || 0) > 0) return 'delayed';
    var heartbeatMins = minsAgo(stock.lastHeartbeatAt);
    var successMins = minsAgo(stock.lastSuccessAt);
    if(heartbeatMins !== null && heartbeatMins > 30) return 'delayed';
    if(successMins !== null && successMins > 180 && stock.enabled !== false) return 'delayed';
    return 'online';
  }
  function friendlyStockState(stock){
    if(!stock || stock.enabled === false) return 'disabled';
    var raw = String(stock.state || stock.status || '').trim();
    var lower = raw.toLowerCase();
    if(!raw) return 'active';
    if(lower.indexOf('target') >= 0 || lower.indexOf('checking') >= 0 || lower.indexOf('check') >= 0 || lower.indexOf('refresh') >= 0 || lower.indexOf('import') >= 0 || lower.indexOf('sync') >= 0) return 'syncing stock';
    if(lower.indexOf('fail') >= 0 || lower.indexOf('error') >= 0 || lower.indexOf('blocked') >= 0) return 'needs attention';
    if(lower.indexOf('warn') >= 0 || lower.indexOf('delay') >= 0 || lower.indexOf('stale') >= 0) return 'delayed';
    if(lower.indexOf('ok') >= 0 || lower.indexOf('ready') >= 0 || lower.indexOf('active') >= 0 || lower.indexOf('healthy') >= 0 || lower.indexOf('online') >= 0 || lower.indexOf('running') >= 0) return 'active';
    return raw.replace(/target/ig, 'stock');
  }
  function buildTitle(data){
    var stock = data.stockSync || {};
    var quote = data.quoteReceiver || {};
    var parts = [];
    parts.push('Admin Hub connected');
    if(data.appVersion) parts.push('Version ' + data.appVersion);
    parts.push('Stock sync: ' + friendlyStockState(stock));
    parts.push('Last stock success: ' + agoText(stock.lastSuccessAt));
    parts.push('Stock heartbeat: ' + agoText(stock.lastHeartbeatAt));
   // parts.push('Last quote: ' + agoText(quote.lastQuoteAt));
    return parts.join(' · ');
  }
  function init(el){
    var endpoint = el.dataset.endpoint || 'https://quotes.dlbuilds.co.uk/api/adminhub-status';
    var onlineText = el.dataset.onlineText || 'DLBuilds sync online';
    var delayedText = el.dataset.delayedText || 'DLBuilds sync delayed';
    var offlineText = el.dataset.offlineText || 'DLBuilds sync offline';
    var checkingText = el.dataset.checkingText || 'Checking DLBuilds sync';
    async function check(){
      setState(el, 'checking', checkingText, 'Syncing stock status...');
      try{
        var data = await fetchWithTimeout(endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') + 't=' + Date.now(), 5500);
        var state = classify(data);
        setState(el, state, state === 'online' ? onlineText : state === 'delayed' ? delayedText : offlineText, buildTitle(data));
      } catch(err){
        setState(el, 'offline', offlineText, 'Could not reach Admin Hub status endpoint. The site will still work, but live sync may be offline.');
      }
    }
    check();
    setInterval(check, 60000);
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-dlb-adminhub-status]').forEach(init);
  });
})();
